import React, { useEffect, useState, useContext } from 'react';
import '../Estilos/Fontes.css';
import '../Estilos/Container.css';
import '../Estilos/Componentes.css';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuOpcoes from '../Funções/MenuOpcoes';
import { StoreContexto } from '../Contexto/Provider';

export default function BarraLateral() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuEscolha, setMenuEscolha] = useState('Geral');

  const { auth } = useContext(StoreContexto);

  useEffect(() => {
    MenuOpcoes.map((item) => {
      if (
        pathname === item.navega ||
        (pathname.search('/Geladeira') !== -1 && item.navega.search('/Geladeira') !== -1)
      ) {
        setMenuEscolha(item.tag);
      }
    });
  }, [pathname]);

  return (
    <div style={{ backgroundColor: '#005288', minHeight: '100vh', top: 0, position: 'sticky' }}>
      <div className="barraLateral">
        {MenuOpcoes.map((item) => {
          if (item.roles.includes(auth.perfilSalvo) || item.roles.length === 0) {
            return (
              <div
                id={item.nome}
                key={item.nome}
                className={
                  menuEscolha === item.tag && pathname !== '/wellcome'
                    ? 'opcoesBarra Selecionado'
                    : 'opcoesBarra'
                }
                onClick={() => navigate(item.navega)}
              >
                <img src={item.icone} height={33} width={33} style={{ marginTop: 0 }} alt="" />
                <h3 className="unselectable" id="opcoesFonte">
                  {item.nome}
                </h3>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
